import { ShieldUser } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Faixa de aviso quando a sessão foi aberta pelo suporte (handoff) em vez do
 * login do próprio usuário.
 *
 * Entrar na conta do cliente sem senha só é aceitável se ficar visível: sem a
 * faixa, ninguém que olhasse a tela — nem o próprio técnico — saberia em qual
 * conta está agindo.
 *
 * A marca é gravada no sessionStorage pelo `entrarComHandoff` e morre com a aba.
 */
export default function SuporteBanner() {
  const bruto = sessionStorage.getItem("suporte_sessao");
  if (!bruto) return null;

  let dados: { nome?: string; cliente?: string };
  try {
    dados = JSON.parse(bruto);
  } catch {
    return null;
  }

  function encerrar() {
    sessionStorage.clear();
    localStorage.removeItem("access_token");
    localStorage.removeItem("usuario_local_info");
    window.location.href = "/auth";
  }

  return (
    <div className="flex items-center gap-3 border-b border-amber-500/40 bg-amber-500/15 px-4 py-2 text-sm">
      <ShieldUser className="h-5 w-5 shrink-0 text-amber-600" />
      <div className="flex flex-1 flex-wrap items-center gap-x-2">
        <span className="font-medium">Sessão de suporte</span>
        <span className="text-muted-foreground">
          {dados.nome ? `aberta por ${dados.nome}` : "aberta pela equipe de suporte"}
          {dados.cliente ? ` · acessando como ${dados.cliente}` : ""}
        </span>
      </div>
      <Button variant="outline" size="sm" onClick={encerrar}>
        Encerrar
      </Button>
    </div>
  );
}
